import { render, staticRenderFns } from "./RoomConfiguration.vue?vue&type=template&id=2435d116&"
import script from "./RoomConfiguration.vue?vue&type=script&lang=js&"
export * from "./RoomConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports